import selectContact from 'assets/images/icon-v1/dlvr-import-contact-icon.png'
import longhaulBlackIcon from 'assets/images/webapp-v2/icon-long-haul-black.svg'
import longHaulGrayIcon from 'assets/images/webapp-v2/icon-long-haul-dark.svg'
import saveIconEzsheet from 'assets/images/webapp-v2/saved-icon-ezsheet.svg'
import iconDistanceCalculator from 'assets/images/webapp-v2/icon-distance-calculator.svg'
import longHaulWhiteIcon from 'assets/images/webapp-v2/icon-long-haul-white.svg'
import iconBatchCompletedOutline from 'assets/images/webapp-v2/icon-batch/icon_batch_completed_outline.svg'
import iconBatchCompletedDark from 'assets/images/webapp-v2/icon-batch/icon_batch_completed_dark.svg'
import multipleDraftIcon from 'assets/images/webapp-v2/BookingWizard-Actions-Draft.png'
import searchIconMultiple from 'assets/images/webapp-v2/icon-search.svg'
import deleteIconEzsheet from 'assets/images/webapp-v2/delete-booking.svg'
import deleteSilverIconEzsheet from 'assets/images/webapp-v2/delete-booking-silver.svg'
import googlePlayStore from 'assets/images/webapp-v2/share/googleplay_store.svg'
import appleStore from 'assets/images/webapp-v2/share/apple_store.svg'
import webappStore from 'assets/images/webapp-v2/share/webapp_store.svg'
import iconPhoneWhite from 'assets/images/webapp-v2/share/dlvr-phone-icon-white.svg'
import iconContactUs from 'assets/images/webapp-v2/popup/008-contact-us.svg'
import iconFacebook from 'assets/images/webapp-v2/social/facebook-icon.png'
import iconGoogle from 'assets/images/webapp-v2/social/google-icon.svg'
import exportIconChart from 'assets/images/webapp-v2/dashboard-analytics/export-icon.svg'
import analyticsReportIconChart from 'assets/images/webapp-v2/dashboard-analytics/analytics-report-icon.svg'
import exportExcelIconChart from 'assets/images/webapp-v2/dashboard-analytics/export-excel-icon.svg'
import exportXLSIcon from 'assets/images/webapp-v2/dashboard-analytics/asset-xls.svg'
import exportDownloadFailIcon from 'assets/images/webapp-v2/dashboard-analytics/download_fail.svg'
import exportPDFIconChart from 'assets/images/webapp-v2/dashboard-analytics/export-pdf-icon.svg'
import downloadPDFIconChart from 'assets/images/webapp-v2/dashboard-analytics/downloadPDF.svg'
import iconDropdown from 'assets/images/webapp-v2/dashboard-analytics/dropdown-icon.svg'
import avgIconChart from 'assets/images/webapp-v2/dashboard-analytics/icon-avg.svg'
import loadingIconChart from 'assets/images/webapp-v2/dashboard-analytics/loading.svg'
import noDataIconChart from 'assets/images/webapp-v2/dashboard-analytics/no-data.svg'
import locatingGifGreen from 'assets/images/webapp-v2/Rolling_Green.svg'
import pdfIconChat from 'assets/images/webapp-v2/chat/PDF.svg'
import wordIconChat from 'assets/images/webapp-v2/chat/word.svg'
import assignDriverIconChat from 'assets/images/webapp-v2/chat/icon-assign-driver.svg'
import messageDriverIconChat from 'assets/images/webapp-v2/chat/icon-message-driver.svg'
import iconChat from 'assets/images/webapp-v2/chat/icon-chat.png'
import selectContactActive from 'assets/images/icon-v1/dlvr-import-contact-active-icon.png'
import routeDotGreen from 'assets/images/icon-v1/dlvr-from-solid-icon.png'
import routeDotBlue from 'assets/images/icon-v1/dlvr-to-solid-blue-icon.png'
import routeDotYellow from 'assets/images/icon-v1/dlvr-to-solid-yellow-icon.png'
import routeDotYellow1 from 'assets/images/icon-v1/dlvr-to-solid-yellow-icon-1.png'
import routeDotYellow2 from 'assets/images/icon-v1/dlvr-to-solid-yellow-icon-2.png'
import routeDotYellow3 from 'assets/images/icon-v1/dlvr-to-solid-yellow-icon-3.png'
import routeDotYellow4 from 'assets/images/icon-v1/dlvr-to-solid-yellow-icon-4.png'
import routeDotYellow5 from 'assets/images/icon-v1/dlvr-to-solid-yellow-icon-5.png'
import routeDotYellow6 from 'assets/images/icon-v1/dlvr-to-solid-yellow-icon-6.png'
import routeDotYellow7 from 'assets/images/icon-v1/dlvr-to-solid-yellow-icon-7.png'
import routeDotYellow8 from 'assets/images/icon-v1/dlvr-to-solid-yellow-icon-8.png'
import routeDotYellow9 from 'assets/images/icon-v1/dlvr-to-solid-yellow-icon-9.png'
import routeDotYellow10 from 'assets/images/icon-v1/dlvr-to-solid-yellow-icon-10.png'
import pinFrom from 'assets/images/web_assets/PinFrom.png'
import pinFromEN from 'assets/images/web_assets/PinFrom__EN.png'
import pinFromTH from 'assets/images/web_assets/PinFrom__TH.png'
import pinFromID from 'assets/images/web_assets/PinFrom__ID.png'
import pinToYellow from 'assets/images/web_assets/PinToYellow.png'
import pinToYellow1 from 'assets/images/web_assets/PinToYellow_1.png'
import pinToYellow2 from 'assets/images/web_assets/PinToYellow_2.png'
import pinToYellow3 from 'assets/images/web_assets/PinToYellow_3.png'
import pinToYellow4 from 'assets/images/web_assets/PinToYellow_4.png'
import pinToYellow5 from 'assets/images/web_assets/PinToYellow_5.png'
import pinToYellow6 from 'assets/images/web_assets/PinToYellow_6.png'
import pinToYellow7 from 'assets/images/web_assets/PinToYellow_7.png'
import pinToYellow8 from 'assets/images/web_assets/PinToYellow_8.png'
import pinToYellow9 from 'assets/images/web_assets/PinToYellow_9.png'
import pinToYellow10 from 'assets/images/web_assets/PinToYellow_10.png'
import businessDefaultLogo from 'assets/images/web_assets/BusinessDefaultLogo.jpg'
import pinToBlue from 'assets/images/web_assets/PinToBlue.png'
import iconCSAvatar from 'assets/images/icon-v1/cs-avatar.png'
import iconEdit from 'assets/images/icon-v1/edit.png'
import iconEditActive from 'assets/images/icon-v1/edit-active.png'
import iconShareNode from 'assets/images/icon-v1/share-node.png'
import iconShareNodeActive from 'assets/images/icon-v1/share-node-active.png'
import iconCancel from 'assets/images/icon-v1/ic_cancelmanagement.png'
import iconCarGray from 'assets/images/webapp-v2/car_gray.svg'
import noDriverFound from 'assets/images/webapp-v2/no_driver_found.svg'
import iconBatchManagement from 'assets/images/webapp-v2/batch_management.svg'
import iconSwitchBatch from 'assets/images/webapp-v2/switch_icon_batch.svg'
import pdfIcon from 'assets/images/web_assets/pdf_icon.svg'
import thanksIcon from 'assets/images/webapp-v2/thanks.svg'
import infoBoxYellow from 'assets/images/web_assets/InfoBoxYellow.png'
import infoBoxYellowGif from 'assets/images/web_assets/InfoBoxYellow.gif'
import shareTrackingIcon from 'assets/images/webapp-v2/share_tracking_info.svg'
import logoAppStore from 'assets/images/webapp-v2/share/app-store-white.png'
import iconPhoneBlack from 'assets/images/webapp-v2/share/dlvr-phone-icon-black.png'
import iconPhoneGreen from 'assets/images/webapp-v2/share/dlvr-phone-icon-green.png'
import logoGooglePlay from 'assets/images/webapp-v2/share/google-play-white.png'
import pinRed from 'assets/images/webapp-v2/Pin-Red.png'
import pinYellow from 'assets/images/webapp-v2/Pin-Yellow.png'
import pinBlue from 'assets/images/webapp-v2/Pin-Blue.png'
import noSignal from 'assets/images/webapp-v2/ic_offline.png'
import v2IconWhite from 'assets/images/webapp-v2/Icon_Deliveree_White.svg'
import v2IconGreen from 'assets/images/webapp-v2/Icon_Deliveree_Green.svg'
import v2LogoWhite from 'assets/images/webapp-v2/Logo_Deliveree_White.svg'
import v2LogoGreen from 'assets/images/webapp-v2/Logo_Deliveree_Green.svg'
import v2IconWhiteTransportify from 'assets/images/webapp-v2/Icon_Transportify_White.svg'
import v2IconGreenTransportify from 'assets/images/webapp-v2/Icon_Transportify_Green.svg'
import v2LogoWhiteTransportify from 'assets/images/webapp-v2/Logo_Transportify_White.svg'
import v2LogoGreenTransportify from 'assets/images/webapp-v2/Logo_Transportify_Green.svg'
import faviconPng from 'assets/images/webapp-v2/favicon.png'
import faviconPngTransportify from 'assets/images/webapp-v2/favicon_transportify.png'
import extendServiceIcon from 'assets/images/webapp-v2/extend_service_icon.png'
import extendMapIcon from 'assets/images/webapp-v2/map.svg'
import changeTimeTypeIcon from 'assets/images/webapp-v2/icon-timetype-switch-full.svg'
import devina1Photo from 'assets/images/webapp-v2/devina-1.4e613f96.png'
import devina2Photo from 'assets/images/webapp-v2/devina-2.de346b57.png'
import devina3Photo from 'assets/images/webapp-v2/devina-4.a19ae046.png'
import devina4Photo from 'assets/images/webapp-v2/devina-5.7df4b305.png'
import devinaIcon from 'assets/images/webapp-v2/devina-icon.png'
import ribbonTail from 'assets/images/webapp-v2/ribbon-tail.png'
import iconWarningDevina from 'assets/images/webapp-v2/Warning.svg'
import iconDoneDevina from 'assets/images/webapp-v2/Check-done.svg'
import iconCheck from 'assets/images/webapp-v2/check.svg'
import multipleAddIcon from 'assets/images/webapp-v2/BookingWizard-Actions-Add.png'
import multipleSaveIcon from 'assets/images/webapp-v2/BookingWizard-Actions-Saved.png'
import batchSelectMultiple from 'assets/images/webapp-v2/multiple/multiple.png'
import batchSelectEZSheet from 'assets/images/webapp-v2/multiple/EZSpreadsheet.png'
import batchSelectLoadDraft from 'assets/images/webapp-v2/multiple/LoadDraft.png'
import batchSelectLoadSaved from 'assets/images/webapp-v2/multiple/LoadSaved.png'
import batchSelectStartFresh from 'assets/images/webapp-v2/multiple/StartFresh.png'
import cashBackPriceNoteIcon from 'assets/images/webapp-v2/cash-back-price-note-icon.svg'
import popupIconSignature from 'assets/images/webapp-v2/popup/001-signature-with-a-pen.svg'
import popupIconAttached from 'assets/images/webapp-v2/popup/002-attached.svg'
import popupIconNotes from 'assets/images/webapp-v2/popup/003-note.svg'
import popupIconDriverNotes from 'assets/images/webapp-v2/popup/003-dnote.svg'
import popupProofOfDelivery from 'assets/images/webapp-v2/popup/009-goods.svg'
import popupPodCod from 'assets/images/webapp-v2/popup/010-cod.png'

import popupIconPrice from 'assets/images/webapp-v2/popup/004-commerce.svg'
import popupIconPriceCancel from 'assets/images/webapp-v2/popup/004-commerce-cancel.svg'
import popupIconAddresses from 'assets/images/webapp-v2/popup/005-gps.svg'
import popupIconAssignment from 'assets/images/webapp-v2/popup/assignment-material.svg'
import locatingDriver from 'assets/images/webapp-v2/Car.svg'
import locatingGif from 'assets/images/webapp-v2/Rolling.svg'
import locatingGifGray from 'assets/images/webapp-v2/Rolling_gray.svg'
import infoIconEZSheet from 'assets/images/webapp-v2/info-icon.svg'
import infoWhiteIconEZSheet from 'assets/images/webapp-v2/info-white-icon.svg'
import settingIconEZSheet from 'assets/images/webapp-v2/setting-icon.svg'
import excelIconEZSheet from 'assets/images/webapp-v2/page-1.svg'
import expandIconEZSheet from 'assets/images/webapp-v2/expand.svg'
import contactIconEZSheet from 'assets/images/webapp-v2/contact-icon.svg'
import vehicleIconEZSheet from 'assets/images/webapp-v2/vehicle-icon.svg'
import pickupIconEZSheet from 'assets/images/webapp-v2/pickup-icon.svg'
import mapIconEZSheet from 'assets/images/webapp-v2/map-icon.svg'
import duplicateIconEZSheet from 'assets/images/webapp-v2/duplicate-booking.svg'
import duplicateSilverIconEZSheet from 'assets/images/webapp-v2/duplicate-booking-silver.svg'
import pinMap1 from 'assets/images/webapp-v2/Pin-Map/Pin-Map-1.png'
import pinMap2 from 'assets/images/webapp-v2/Pin-Map/Pin-Map-2.png'
import pinMap3 from 'assets/images/webapp-v2/Pin-Map/Pin-Map-3.png'
import pinMap4 from 'assets/images/webapp-v2/Pin-Map/Pin-Map-4.png'
import pinMap5 from 'assets/images/webapp-v2/Pin-Map/Pin-Map-5.png'
import pinMap6 from 'assets/images/webapp-v2/Pin-Map/Pin-Map-6.png'
import pinMap7 from 'assets/images/webapp-v2/Pin-Map/Pin-Map-7.png'
import pinMap8 from 'assets/images/webapp-v2/Pin-Map/Pin-Map-8.png'
import pinMap9 from 'assets/images/webapp-v2/Pin-Map/Pin-Map-9.png'
import pinMap10 from 'assets/images/webapp-v2/Pin-Map/Pin-Map-10.png'
import infoBox1 from 'assets/images/webapp-v2/Infobox/InfoBox-Map-1.png'
import infoBox2 from 'assets/images/webapp-v2/Infobox/InfoBox-Map-2.png'
import infoBox3 from 'assets/images/webapp-v2/Infobox/InfoBox-Map-3.png'
import infoBox4 from 'assets/images/webapp-v2/Infobox/InfoBox-Map-4.png'
import infoBox5 from 'assets/images/webapp-v2/Infobox/InfoBox-Map-5.png'
import infoBox6 from 'assets/images/webapp-v2/Infobox/InfoBox-Map-6.png'
import infoBox7 from 'assets/images/webapp-v2/Infobox/InfoBox-Map-7.png'
import infoBox8 from 'assets/images/webapp-v2/Infobox/InfoBox-Map-8.png'
import infoBox9 from 'assets/images/webapp-v2/Infobox/InfoBox-Map-9.png'
import infoBox10 from 'assets/images/webapp-v2/Infobox/InfoBox-Map-10.png'
import pinRoundTripIcon from 'assets/images/webapp-v2/Pin-Map/pin_round_trip_icon.png'
import pinRoundTripIconID from 'assets/images/webapp-v2/Pin-Map/pin_round_trip_icon_ID.png'
import pinRoundTripIconTH from 'assets/images/webapp-v2/Pin-Map/pin_round_trip_icon_TH.png'
import animateCircle from 'assets/images/webapp-v2/Ripple-2.5s-120px.svg'
import iconBatchArranging from 'assets/images/webapp-v2/icon-batch/icon_batch_arranging.svg'
import iconBatchCanceled from 'assets/images/webapp-v2/icon-batch/icon_batch_canceled.svg'
import iconBatchCompleted from 'assets/images/webapp-v2/icon-batch/icon_batch_completed.svg'
import iconBatchCompletedGreen from 'assets/images/webapp-v2/icon-batch/icon_batch_completed_green.svg'
import iconBatchConfirmed from 'assets/images/webapp-v2/icon-batch/icon_batch_confirmed.svg'
import iconBatchDraft from 'assets/images/webapp-v2/icon-batch/icon_batch_draft.svg'
import iconBatchInProgress from 'assets/images/webapp-v2/icon-batch/icon_batch_inProgress.svg'
import iconBatchUnConfirmed from 'assets/images/webapp-v2/icon-batch/icon_batch_unconfirmed.svg'
import quoteIconChat from 'assets/images/webapp-v2/icon-quote.svg'
import emptyIconChat from 'assets/images/webapp-v2/icon_chat_batch.svg'
import fixedPriceIconLongHaul from 'assets/images/webapp-v2/longhaul/fixed-price-icon-longhaul.svg'
import freeInsideIconLongHaul from 'assets/images/webapp-v2/longhaul/free-inside-icon-longhaul.svg'
import priceOutsideIconLongHaul from 'assets/images/webapp-v2/longhaul/price-outside-icon-longhaul.svg'
import fullDayGrayIcon from 'assets/images/webapp-v2/Icon-full-day-gray.svg'
import fullDayDarkGrayIcon from 'assets/images/webapp-v2/Icon-full-day-dark-gray.svg'
import fullDayWhiteIcon from 'assets/images/webapp-v2/Icon-full-day-white.svg'
import completedDarkGrayIcon from 'assets/images/webapp-v2/Icon-completed-day-dark.svg'
import roundTripDiscountPinNoneIcon from 'assets/images/webapp-v2/pin/pin_round_trip_icon_none.png'
import flagVNIcon from 'assets/images/webapp-v2/select-area/vietnam.svg'
import flagTHIcon from 'assets/images/webapp-v2/select-area/thailand.svg'
import flagPHIcon from 'assets/images/webapp-v2/select-area/philippines.svg'
import flagIDIcon from 'assets/images/webapp-v2/select-area/indonesia.svg'
import flagVNIconRect from 'assets/images/webapp-v2/flags/vn.svg'
import flagTHIconRect from 'assets/images/webapp-v2/flags/th.svg'
import flagPHIconRect from 'assets/images/webapp-v2/flags/ph.svg'
import flagIDIconRect from 'assets/images/webapp-v2/flags/id.svg'
import iconFlagEn from 'assets/images/webapp-v2/flags/en.png'
import iconFlagId from 'assets/images/webapp-v2/flags/id.png'
import iconFlagTh from 'assets/images/webapp-v2/flags/th.png'
import arrowIcon from 'assets/images/webapp-v2/arrow.svg'
import arrowYellowIcon from 'assets/images/webapp-v2/arrow_yellow.svg'
import iconQuoteID from 'assets/images/webapp-v2/popup/012-quoteID.svg'
import iconDriverPreferences from 'assets/images/webapp-v2/popup/013-driver.svg'
import iconDriverPreferencesFull from 'assets/images/webapp-v2/icon-driver-preferences-full.svg'
import iconDriverPreferenceSwitchTabPopup from 'assets/images/webapp-v2/icon-driver-preferences.svg'
import icondriverSchedule from 'assets/images/webapp-v2/Driver_Schedule_Icon.png'
import iconDriverRetry from 'assets/images/webapp-v2/popup/015-driver-retry.svg'
import iconRetryBooking2ndManual from 'assets/images/webapp-v2/popup/ic_retry.png'
import iconCancelFee from 'assets/images/webapp-v2/popup/017-cancel-fee.svg'
import showRouteButtonActive from 'assets/images/webapp-v2/show-routes/button-active.svg'
import showRouteButtonNotActive from 'assets/images/webapp-v2/show-routes/button-unactive.svg'
import showRouteButtonActiveEN from 'assets/images/webapp-v2/show-routes/button-active-en.png'
import showRouteButtonActiveTHI from 'assets/images/webapp-v2/show-routes/button-active-thai.png'
import showRouteButtonActiveIDI from 'assets/images/webapp-v2/show-routes/button-active-indo.png'
import showRouteButtonNotActiveEN from 'assets/images/webapp-v2/show-routes/button-not-active-en.png'
import showRouteButtonNotActiveTHI from 'assets/images/webapp-v2/show-routes/button-not-active-thai.png'
import showRouteButtonNotActiveIDI from 'assets/images/webapp-v2/show-routes/button-not-active-indo.png'
import showRouteRoundTripPinEN from 'assets/images/webapp-v2/show-routes/phi.svg'
import showRouteRoundTripPinTHI from 'assets/images/webapp-v2/show-routes/thai.svg'
import showRouteRoundTripPinIDI from 'assets/images/webapp-v2/show-routes/ind.svg'
import iconCancelBooking from 'assets/images/webapp-v2/popup/015-cancel.svg'
import iconCsHelp from 'assets/images/webapp-v2/popup/023-icon-cs-help.svg'
import iconInfoRed from 'assets/images/webapp-v2/popup/016-info.svg'
import iconBatchNeedConfirm from 'assets/images/webapp-v2/icon-batch/icon-batch-need-confirm.png'
import filterExportIcon from 'assets/images/webapp-v2/filter_export.svg'
import locatingDriverDefaultImage from 'assets/images/webapp-v2/Locating_Driver_Default_Image.jpeg'
import reassignIcon from 'assets/images/webapp-v2/Fill.svg'
import iconCebRequestChanges from 'assets/images/webapp-v2/popup/017-icon-ceb-request-changes.svg'
import iconCebReconfirmedBooking from 'assets/images/webapp-v2/popup/019-icon-ceb-reconfirmed.svg'
import iconAvatarFleetPartnerAssignDriver from 'assets/images/webapp-v2/icon-avatar-fleet-partner-assign-driver.png'
import iconConfirmCancelInprogress from 'assets/images/webapp-v2/popup/020-icon-confirm-cancel-inprogress.svg'
import iconDriverPreferencesFavorite from 'assets/images/webapp-v2/popup/021-driver-favorite.svg'
import iconDriverPreferencesBanned from 'assets/images/webapp-v2/popup/022-driver-banned.svg'
import iconArrowDownDarkGreen from 'assets/images/webapp-v2/arrow-down-dark-green.svg'
import iconInfoUnActive from 'assets/images/webapp-v2/info-unactive.svg'
import iconInfoActive from 'assets/images/webapp-v2/info-active.svg'
import iconCancelReason from 'assets/images/webapp-v2/cancel-reason.svg'
import iconCancelled from 'assets/images/webapp-v2/cancelled.svg'
import iconEditLocations from 'assets/images/webapp-v2/my-location/edit-icon.svg'
import iconCustomReimbursement from 'assets/images/webapp-v2/icon-custom-reimbursement.svg'
import iconNoteCustomPrice from 'assets/images/webapp-v2/icon-note-custom-price.svg'
import iconICErrCode from 'assets/images/webapp-v2/ic_error_code.png'
import iconFavDriverAdded from 'assets/images/webapp-v2/popup/024-fav-driver.png'
import iconArrowUp from 'assets/images/webapp-v2/icon-arrow-up.png'
import iconAssetsDriverApp from 'assets/images/webapp-v2/assets_driver_app_custom_reimbursement.png'
import noFavoriteDrivers from 'assets/images/webapp-v2/no-favorite-drivers.svg'
import questionIcon from 'assets/images/webapp-v2/icon-question.svg'
import questionIconGray from 'assets/images/webapp-v2/icon-question-gray.svg'
import questionIconGreen from 'assets/images/webapp-v2/icon-question-green.svg'
import addNewBooking from 'assets/images/webapp-v2/add-new-booking.svg'
import outlineAddNewBooking from 'assets/images/webapp-v2/outline-add-new-booking.svg'
import uploadImage from 'assets/images/webapp-v2/upload-image.svg'
import logOutImage from 'assets/images/webapp-v2/Logout.svg'
import logOutIconLogoPH from 'assets/images/webapp-v2/icon-logos/Icon_Transportify_Green.svg'
import logOutIconLogo from 'assets/images/webapp-v2/icon-logos/Icon_Deliveree_Green.svg'
import supporter from 'assets/images/webapp-v2/supporter.png'
import arrowUpRight from 'assets/images/webapp-v2/arrow-up-right.svg'

import favoriteIcon from 'assets/images/webapp-v2/favorite.svg'
import unFavoriteIcon from 'assets/images/webapp-v2/favorite_stoke.svg'
import bannedIcon from 'assets/images/webapp-v2/banned.svg'
import unbannedIcon from 'assets/images/webapp-v2/un_banned.svg'
import favoriteGrayIcon from 'assets/images/webapp-v2/favorite-gray.svg'
import iconScheduleYellow from 'assets/images/webapp-v2/closure/card-booking/schedule-yellow.svg'

import locationIcon from 'assets/images/webapp-v2/my-location/location.svg'
import locationNameIcon from 'assets/images/webapp-v2/my-location/name.svg'
import locationAddressIcon from 'assets/images/webapp-v2/my-location/address.svg'
import locationNumberIcon from 'assets/images/webapp-v2/my-location/number.svg'
import locationTitleIcon from 'assets/images/webapp-v2/my-location/title.svg'
import locationEmailIcon from 'assets/images/webapp-v2/my-location/email.svg'
import locationCompanyIcon from 'assets/images/webapp-v2/my-location/company.svg'
import trashIcon from 'assets/images/webapp-v2/my-location/trash.svg'
import addressDetailIcon from 'assets/images/webapp-v2/my-location/address-detail.svg'
import calendarIcon from 'assets/images/webapp-v2/date.svg'
import quickChoiceIcon from 'assets/images/webapp-v2/time.svg'
import arrowDownGreen from 'assets/images/webapp-v2/arrow-down-green.svg'
import bpAccount from 'assets/images/webapp-v2/bp-account.svg'
import switchAccount from 'assets/images/webapp-v2/switch-account.svg'
import noLocation from 'assets/images/webapp-v2/no_location.svg'

import arrowRightGreen from 'assets/images/webapp-v2/arrow-right-green.svg'
import arrowBackWhite from 'assets/images/webapp-v2/arrow-back-white.svg'

import warningYellow from 'assets/images/webapp-v2/warning-yellow.svg'

import hambugerCommonIcon from 'assets/images/webapp-v2/common/hambuger.svg'
import clearCommonIcon from 'assets/images/webapp-v2/common/clear.svg'
import locationCommonIcon from 'assets/images/webapp-v2/common/location.svg'
import removeCommonIcon from 'assets/images/webapp-v2/common/remove.svg'
import saveCommonIcon from 'assets/images/webapp-v2/common/save.svg'
import gpsCommonIcon from 'assets/images/webapp-v2/common/gps.svg'
import pathCommonIcon from 'assets/images/webapp-v2/common/path.svg'
import moveDragIcon from 'assets/images/webapp-v2/common/icon-move-drag.svg'

import distanceCalculator from 'assets/images/webapp-v2/distance-calculator.svg'
import iconCheckeDefault from 'assets/images/webapp-v2/icon-checked-default.svg'

// Not Require Signatures
import popupIconNotRequireSignaturesEN from 'assets/images/webapp-v2/popup/signature-not-required-EN.png'
import popupIconNotRequireSignaturesID from 'assets/images/webapp-v2/popup/signature-not-required-ID.png'
import popupIconNotRequireSignaturesTH from 'assets/images/webapp-v2/popup/signature-not-required-TH.png'
import popupIconNotRequireSignaturesVN from 'assets/images/webapp-v2/popup/signature-not-required-VN.png'
import megazoneNoticeIcon from 'assets/images/webapp-v2/common/notice_megazone.svg'
import closeNoticeMegazoneIcon from 'assets/images/webapp-v2/common/close-notice-megazone.svg'

// TimeType icon
import nowIcon from 'assets/images/webapp-v2/closure/quick.svg'
import scheduleIcon from 'assets/images/webapp-v2/closure/schedule.svg'
import fullDayIcon from 'assets/images/webapp-v2/closure/fullday.svg'

// Closure
import ltlBookingIcon from 'assets/images/webapp-v2/closure/card-booking/icon-combo.svg'
import emptyBookingsIcon from 'assets/images/webapp-v2/closure/card-booking/car-gray.svg'
import canceledBookingIcon from 'assets/images/webapp-v2/closure/card-booking/booking-cancel.png'
import completedBookingIcon from 'assets/images/webapp-v2/closure/card-booking/booking-complete.png'
import nowBookingIcon from 'assets/images/webapp-v2/closure/card-booking/car.svg'
import scheduleBookingIcon from 'assets/images/webapp-v2/closure/card-booking/scheduled.svg'
import fullDayBookingIcon from 'assets/images/webapp-v2/closure/card-booking/fullday.svg'
import longHaulBookingIcon from 'assets/images/webapp-v2/closure/card-booking/long-haul.svg'
import draftBookingIcon from 'assets/images/webapp-v2/closure/card-booking/draft.svg'
import deleteIcon from 'assets/images/webapp-v2/closure/card-booking/delete-icon.png'
import deleteIconPopup from 'assets/images/webapp-v2/closure/card-booking/006-delete.svg'
import chatIcon from 'assets/images/webapp-v2/closure/chat/icon-chat.png'
import infoIcon from 'assets/images/webapp-v2/closure/chat/icon-info.png'
import quoteIcon from 'assets/images/webapp-v2/closure/chat/icon-quote.svg'
import avatarDriver from 'assets/images/webapp-v2/closure/card-booking/avatar.png'
import goodsIcon from 'assets/images/webapp-v2/closure/list-booking/goods.svg'
import iconPerson from 'assets/images/webapp-v2/person-icon.svg'
import iconPersonPayment from 'assets/images/webapp-v2/person-icon-payment.svg'
import searchNewIcon from 'assets/images/webapp-v2/search-new-icon.svg'
import saveNewIcon from 'assets/images/webapp-v2/icon-save-bookings.svg'
import arrowRightIcon from 'assets/images/webapp-v2/arrow-right-icon.svg'
import deleteIconConfirm from 'assets/images/webapp-v2/closure/popup/012-delete.svg'
import iconCebReconfirmed from 'assets/images/webapp-v2/closure/popup/icon_ceb_reconfirmed.svg'

// Shopping
import copyShopping from 'assets/images/webapp-v2/shopping/copy.svg'
import walletShopping from 'assets/images/webapp-v2/shopping/wallet.svg'
import blockBookingShopping from 'assets/images/webapp-v2/shopping/block-booking.svg'
import cartShopping from 'assets/images/webapp-v2/shopping/shopping.svg'
import trashIconShopping from 'assets/images/webapp-v2/shopping/trash.svg'
import checkIconShopping from 'assets/images/webapp-v2/common/check.svg'
import checkGrayIconShopping from 'assets/images/webapp-v2/common/check-gray.svg'
import triangleIconShopping from 'assets/images/webapp-v2/common/triangle.svg'
import itemBreakdownIconShopping from 'assets/images/webapp-v2/common/item-breakdown.svg'
import trashIconWhiteShopping from 'assets/images/webapp-v2/common/trash-white.svg'

// CPOD
import emailExpress from 'assets/images/webapp-v2/email-exspress-icon.svg'
import optionalNote from 'assets/images/webapp-v2/optional-note.svg'

// number driver
import numberDriverLeft from 'assets/images/webapp-v2/number-driver-left.png'
import numberDriverRight from 'assets/images/webapp-v2/number-driver-right.png'
import vehicleIcon from 'assets/images/webapp-v2/VehicleIcon.svg'
// time type icon
import iconTimetypeFullday from 'assets/images/webapp-v2/icon-timetype-fullday.svg'
import iconTimetypeSchedule from 'assets/images/webapp-v2/icon-timetype-schedule.svg'
import iconTimetypeQuick from 'assets/images/webapp-v2/icon-timetype-quick.svg'
import iconTimetypeLonghaul from 'assets/images/webapp-v2/icon-timetype-longhaul.svg'
// LTL Icon
import iconMapLTlPopup from 'assets/images/webapp-v2/mapLTLpopup.svg'
import iconScheduleLTL from 'assets/images/webapp-v2/schedule.png'
import iconPartialLoadWhite from 'assets/images/webapp-v2/icon-partial-load-white.png'

// default avatar
import driverDefaultAvatar from 'assets/images/webapp-v2/default-avatar/Drivers.png'

// sub account tag icon
import nounUserTagIcon from 'assets/images/webapp-v2/noun-user-tag-icon.svg'
import greenNounUserTagIcon from 'assets/images/webapp-v2/green-noun-user-tag-icon.svg'
import whiteNounUserTagIcon from 'assets/images/webapp-v2/white-noun-user-tag-icon.svg'
import searchIcon from 'assets/images/webapp-v2/search-icon.svg'
import upAndDownIcon from 'assets/images/webapp-v2/up-and-down-icon.svg'

import smartPlannerSelect from 'assets/images/webapp-v2/smart_load_planner.png'
import ezSheetUpload from 'assets/images/webapp-v2/ez-sheet-upload.png'
import scheduleGrey from 'assets/images/webapp-v2/schedule-gray.svg'
import busGray from 'assets/images/webapp-v2/bus_gray.svg'

import bookingOptions from 'assets/images/webapp-v2/booking-options.svg'
import Reorder from 'assets/images/webapp-v2/reorder.svg'
import infoGreen from 'assets/images/webapp-v2/info-green.svg'
import ReorderGreen from 'assets/images/webapp-v2/reorder-green.svg'

import account from 'assets/images/webapp-v2/account.svg'
import scheduleClock from 'assets/images/webapp-v2/schedule-clock.svg'
import breakFile from 'assets/images/webapp-v2/break-file.svg'

import walletIcon from 'assets/images/webapp-v2/wallet.svg'
import walletGraytIcon from 'assets/images/webapp-v2/wallet-gray.svg'
import startIcon from 'assets/images/webapp-v2/lucky-star.svg'
import imagePlaceHolder from 'assets/images/webapp-v2/missing-v2.png'
import mapGreen from 'assets/images/webapp-v2/map-green.svg'
import mapGray from 'assets/images/webapp-v2/map-gray.svg'
import undoIcon from 'assets/images/webapp-v2/undo.svg'
import undoRedIcon from 'assets/images/webapp-v2/undo-red.svg'
import undoBlackIcon from 'assets/images/webapp-v2/undo-black.svg'
import lightPub from 'assets/images/webapp-v2/light-pub.svg'
import jobNumberIcon from 'assets/images/webapp-v2/job-number.svg'
import infoWithBorder from 'assets/images/webapp-v2/info-border.png'

import computerBatchIcon from 'assets/images/webapp-v2/computer-batch-icon.png'
import excelBatchIcon from 'assets/images/webapp-v2/excel-icon.png'
import mapIconLoadPlan from 'assets/images/webapp-v2/final-leo-graphic.png'
import tmsIcon from 'assets/images/webapp-v2/tmsIcon.png'
import opentmsIcon from 'assets/images/webapp-v2/icon-tms-open.png'
import invalidAccount from 'assets/images/webapp-v2/invalid-account.svg'
import accountCheck from 'assets/images/webapp-v2/account-check.svg'
import closeIcon from 'assets/images/webapp-v2/close-icon.svg'
import backgroundImage from 'assets/images/webapp-v2/bg.d8aeaa66.jpg'

//employee
import switchRoleIcon from 'assets/images/webapp-v2/employee/icon-switch-1-a.svg'
import switchRoleIconColor from 'assets/images/webapp-v2/employee/icon-switch-1-b.svg'
import banIcon from 'assets/images/webapp-v2/employee/icon-ban-2-a.svg'
import banIconColor from 'assets/images/webapp-v2/employee/icon-ban-2-b.svg'
import deleteEmployeeIcon from 'assets/images/webapp-v2/employee/icon-delete-1-a.svg'
import deleteEmployeeIconColor from 'assets/images/webapp-v2/employee/icon-delete-1-b.svg'

// NEW TRACKING BOOKING
import whiteLogo from '../assets/images/webapp-v2/new_tracking_booking/white_logo.svg'
import whiteLogoTransportify from '../assets/images/webapp-v2/new_tracking_booking/white_logo_transportify.svg'
import greenCopy from 'assets/images/webapp-v2/new_tracking_booking/green_copy.svg'
import playStoreAndroid from 'assets/images/webapp-v2/new_tracking_booking/play_store_android.svg'
import playStoreIOS from 'assets/images/webapp-v2/new_tracking_booking/play_store_ios.svg'
import shutterStock from 'assets/images/webapp-v2/new_tracking_booking/shutter_stock.svg'
import booked from 'assets/images/webapp-v2/new_tracking_booking/booked.svg'
import dispatch from 'assets/images/webapp-v2/new_tracking_booking/dispatch.svg'
import pickup from 'assets/images/webapp-v2/new_tracking_booking/pickup.svg'
import delivery from 'assets/images/webapp-v2/new_tracking_booking/delivery.svg'
import bookedOnGoing from 'assets/images/webapp-v2/new_tracking_booking/booked_ongoing.svg'
import dispatchOnGoing from 'assets/images/webapp-v2/new_tracking_booking/dispatch_ongoing.svg'
import pickupOnGoing from 'assets/images/webapp-v2/new_tracking_booking/pickup_ongoing.svg'
import deliveryOnGoing from 'assets/images/webapp-v2/new_tracking_booking/delivery_ongoing.svg'
import bookedCompleted from 'assets/images/webapp-v2/new_tracking_booking/booked_completed.svg'
import dispatchCompleted from 'assets/images/webapp-v2/new_tracking_booking/dispatch_completed.svg'
import pickupCompleted from 'assets/images/webapp-v2/new_tracking_booking/pickup_completed.svg'
import deliveryCompleted from 'assets/images/webapp-v2/new_tracking_booking/delivery_completed.svg'
import deliveryBookingCompleted from 'assets/images/webapp-v2/new_tracking_booking/delivery_booking_completed.svg'
import deliveryBookingCanceled from 'assets/images/webapp-v2/new_tracking_booking/delivery_booking_canceled.svg'
import check from 'assets/images/webapp-v2/new_tracking_booking/check.svg'
import bitmap from 'assets/images/webapp-v2/new_tracking_booking/images/bitmap.png'
import bitmapWithoutRadian from 'assets/images/webapp-v2/new_tracking_booking/images/bitmap_without_radian.png'
import invalidLink from 'assets/images/webapp-v2/new_tracking_booking/invalid_link.svg'
import arrowLeftWhite from 'assets/images/webapp-v2/arrow-left-white.svg'
import paidPaymentIcon from 'assets/images/webapp-v2/paid-payment-icon.svg'

// front page
import ftlFrontPage from 'assets/images/webapp-v2/frontPage/ftl.jpg'
import ptlFrontPage from 'assets/images/webapp-v2/frontPage/ptl.png'
import lclFrontPage from 'assets/images/webapp-v2/frontPage/lcl.jpg'
import moreFrontPageService from 'assets/images/webapp-v2/frontPage/lcl-service.png'
import moreFrontPageServiceId from 'assets/images/webapp-v2/frontPage/lcl-service-id.png'
import moreFrontPageContainer from 'assets/images/webapp-v2/frontPage/lcl-container.png'
import newAdPanel from 'assets/images/webapp-v2/frontPage/New-Ad-Panel.jpg'
import saverLaunchAdPanel from 'assets/images/webapp-v2/frontPage/Saver-Launch-Ad-panel.jpg'
import noSignIn from 'assets/images/webapp-v2/frontPage/no-sign-in.svg'
import liveChat from 'assets/images/webapp-v2/frontPage/live-chat.svg'
import finalLeoGraphic from 'assets/images/webapp-v2/frontPage/final-leo-graphic.svg'
import sumatra from 'assets/images/webapp-v2/frontPage/sumatra.png'
import backToTopIcon from 'assets/images/webapp-v2/frontPage/back-to-top.svg'
import lclBookingIcon from 'assets/images/webapp-v2/frontPage/lcl-ship.svg'
import lclCarIcon from 'assets/images/webapp-v2/frontPage/car-icon.svg'
import lclShipIcon from 'assets/images/webapp-v2/frontPage/ship-icon.svg'
import lclCalendarIcon from 'assets/images/webapp-v2/closure/card-booking/calendar.svg'
import lclTimeIcon from 'assets/images/webapp-v2/closure/card-booking/time-access.svg'

// TOPUP
import topUpFail from 'assets/images/webapp-v2/shopping/topup-fail.svg'
import topUpCheck from 'assets/images/webapp-v2/shopping/check.svg'
import copy from 'assets/images/webapp-v2/shopping/copy-new.svg'

// Share social network
import imageSharing_transportify from '../assets/images/header/imageSharing_transportify.png'
import imageSharing_deliveree from '../assets/images/header/imageSharing_deliveree.png'

// Saver
import saverBlockInfoIcon from 'assets/images/webapp-v2/saver-block-info-icon.svg'
import contactCS from '../assets/images/webapp-v2/chat/contact-cs.svg'

// new map service
import newPinTo from 'assets/images/webapp-v2/pin/new-pin-to.svg'
import newPinFrom from 'assets/images/webapp-v2/pin/new-pin-from.svg'
import newPinRed from 'assets/images/webapp-v2/pin/new-pin-red.svg'

import pinFromDrapDrop from 'assets/images/webapp-v2/pin/pin-from-drap-drop.svg'
import pinFromDrapDropEn from 'assets/images/webapp-v2/pin/pin-from-drap-drop-en.svg'
import pinFromDrapDropId from 'assets/images/webapp-v2/pin/pin-from-drap-drop-id.svg'
import pinFromDrapDropTh from 'assets/images/webapp-v2/pin/pin-from-drap-drop-th.svg'

import pinToDrapDrop from 'assets/images/webapp-v2/pin/pin-to-drap-drop.svg'
import pinToDrapDropEn from 'assets/images/webapp-v2/pin/pin-to-drap-drop-en.svg'
import pinToDrapDropId from 'assets/images/webapp-v2/pin/pin-to-drap-drop-id.svg'
import pinToDrapDropTh from 'assets/images/webapp-v2/pin/pin-to-drap-drop-th.svg'

import showMoreLocation from '../assets/images/webapp-v2/location/show-more-location.svg'
import bookingTrackingIcon from 'assets/images/web_assets/booking-tracking-icon.svg'

// NEW DETAILS BOOKING
import cashBackStar from '../assets/images/webapp-v2/cashback-star.svg'
import caretDown from '../assets/images/webapp-v2/caret_down.svg'
import caretDownWhite from '../assets/images/webapp-v2/caret_down_white.svg'

// Show Route
export const SHOW_ROUTE_BUTTON = {
  active: showRouteButtonActive,
  not_active: showRouteButtonNotActive,
}
export const SHOW_ROUTE_BUTTON_EN = {
  active: showRouteButtonActiveEN,
  not_active: showRouteButtonNotActiveEN,
}
export const SHOW_ROUTE_BUTTON_THI = {
  active: showRouteButtonActiveTHI,
  not_active: showRouteButtonNotActiveTHI,
}
export const SHOW_ROUTE_BUTTON_IDI = {
  active: showRouteButtonActiveIDI,
  not_active: showRouteButtonNotActiveIDI,
}
export const SHOW_ROUTE_ROUND_TRIP_PIN = {
  en: showRouteRoundTripPinEN,
  id: showRouteRoundTripPinIDI,
  th: showRouteRoundTripPinTHI,
}

export const NOW_ICON = nowIcon
export const SCHEDULE_ICON = scheduleIcon
export const FULL_DAY_ICON = fullDayIcon

export const LTL_BOOKING_ICON = ltlBookingIcon
export const ICON_PARTIAL_LOAD_WHITE = iconPartialLoadWhite
export const EMPTY_BOOKINGS_ICON = emptyBookingsIcon
export const CANCELED_BOOKING_ICON = canceledBookingIcon
export const COMPLETED_BOOKING_ICON = completedBookingIcon
export const NOW_BOOKING_ICON = nowBookingIcon
export const SCHEDULE_BOOKING_ICON = scheduleBookingIcon
export const FULL_DAY_BOOKING_ICON = fullDayBookingIcon
export const LONG_HAUL_BOOKING_ICON = longHaulBookingIcon
export const DRAFT_BOOKING_ICON = draftBookingIcon
export const DELETE_DRAFT_BOOKING_ICON = deleteIcon
export const DELETE_DRAFT_POPUP_ICON = deleteIconPopup
export const CLOSURE_CHAT_ICON = chatIcon
export const CLOSURE_INFO_ICON = infoIcon
export const CLOSURE_QUOTE_ICON = quoteIcon
export const AVATAR_DRIVER = avatarDriver
export const GOODS_ICON_CLOSURE = goodsIcon
export const SUPPORTER = supporter
export const SEARCH_NEW_ICON = searchNewIcon
export const SAVE_NEW_ICON = saveNewIcon
export const ARROW_RIGHT_ICON = arrowRightIcon

export const SELECT_CONTACT = selectContact
export const MULTIPLE_DRAFT_ICON = multipleDraftIcon
export const SEARCH_ICON_MULTIPLE = searchIconMultiple
export const ICON_CHECK = iconCheck

export const SELECT_CONTACT_ACTIVE = selectContactActive
export const ROUTE_DOT_GREEN = routeDotGreen
export const ROUTE_DOT_BLUE = routeDotBlue
export const ROUTE_DOT_YELLOW = routeDotYellow
export const ROUTE_DOT_YELLOW_1 = routeDotYellow1
export const ROUTE_DOT_YELLOW_2 = routeDotYellow2
export const ROUTE_DOT_YELLOW_3 = routeDotYellow3
export const ROUTE_DOT_YELLOW_4 = routeDotYellow4
export const ROUTE_DOT_YELLOW_5 = routeDotYellow5
export const ROUTE_DOT_YELLOW_6 = routeDotYellow6
export const ROUTE_DOT_YELLOW_7 = routeDotYellow7
export const ROUTE_DOT_YELLOW_8 = routeDotYellow8
export const ROUTE_DOT_YELLOW_9 = routeDotYellow9
export const ROUTE_DOT_YELLOW_10 = routeDotYellow10

export const PIN_FROM = pinFrom
export const PIN_BLUE_EN = pinFromEN
export const PIN_BLUE_TH = pinFromTH
export const PIN_BLUE_ID = pinFromID
export const PIN_TO_YELLOW = pinToYellow
export const PIN_TO_YELLOW_1 = pinToYellow1
export const PIN_TO_YELLOW_2 = pinToYellow2
export const PIN_TO_YELLOW_3 = pinToYellow3
export const PIN_TO_YELLOW_4 = pinToYellow4
export const PIN_TO_YELLOW_5 = pinToYellow5
export const PIN_TO_YELLOW_6 = pinToYellow6
export const PIN_TO_YELLOW_7 = pinToYellow7
export const PIN_TO_YELLOW_8 = pinToYellow8
export const PIN_TO_YELLOW_9 = pinToYellow9
export const PIN_TO_YELLOW_10 = pinToYellow10
export const BUSINESS_DEFAULT_LOGO = businessDefaultLogo

export const PIN_TO_BLUE = pinToBlue

export const ICON_CS_AVATAR = iconCSAvatar
export const ICON_EDIT = iconEdit
export const ICON_EDIT_ACTIVE = iconEditActive
export const ICON_SHARE_NODE = iconShareNode
export const ICON_SHARE_NODE_ACTIVE = iconShareNodeActive

export const ICON_CANCEL = iconCancel
export const ICON_BATCH_MANAGEMENT = iconBatchManagement
export const ICON_SWITCH_BATCH = iconSwitchBatch
export const ICON_CANCEL_BOOKING = iconCancelBooking
export const ICON_CS_HELP = iconCsHelp
export const ICON_INFO_RED = iconInfoRed
export const ICON_CONFIRM_CANCEL_IN_PROGRESS = iconConfirmCancelInprogress

export const PDF_ICON = pdfIcon
export const BOOKING_TRACKING_ICON = bookingTrackingIcon
export const ICON_CEBRE_CONFIRMED = iconCebReconfirmed
export const THANKS_ICON = thanksIcon
export const ICON_CANCEL_REASON = iconCancelReason
export const ICON_CANCELLED = iconCancelled
// for new booking screens
export const ICON_PDF =
  'data:image/png;base64,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'
// for tracking screens
export const INFO_BOX_YELLOW = infoBoxYellow
export const INFO_BOX_YELLOW_GIF = infoBoxYellowGif
export const SHARE_TRACKING_ICON = shareTrackingIcon
// for sharing screens
export const LOGO_APP_STORE = logoAppStore
export const ICON_PHONE_BLACK = iconPhoneBlack
export const ICON_PHONE_GREEN = iconPhoneGreen
export const ICON_PHONE_WHITE = iconPhoneWhite
export const LOGO_GOOGLE_PLAY = logoGooglePlay
export const GOOGLE_PLAY_STORE = googlePlayStore
export const APPLE_STORE = appleStore
export const WEBAPP_STORE = webappStore
export const ICON_CONTACT_US = iconContactUs
export const FACEBOOK_ICON = iconFacebook
export const GOOGLE_ICON = iconGoogle
// for v2 pin on map
export const PIN_RED = pinRed
export const PIN_YELLOW = pinYellow
export const PIN_BLUE = pinBlue
export const NO_SIGNAL = noSignal
// for v2 app logo and icon
export const V2_ICON_WHITE = v2IconWhite
export const V2_ICON_GREEN = v2IconGreen
export const V2_LOGO_WHITE = v2LogoWhite
export const V2_LOGO_GREEN = v2LogoGreen
export const V2_ICON_GREEN_TRANSPORTIFY = v2IconGreenTransportify
export const V2_LOGO_WHITE_TRANSPORTIFY = v2LogoWhiteTransportify
export const V2_LOGO_GREEN_TRANSPORTIFY = v2LogoGreenTransportify
export const FAVICON_PNG = faviconPng
export const FAVICON_PNG_TRANSPORTIFY = faviconPngTransportify
export const FLAG_VN_ICON = flagVNIcon
export const FLAG_TH_ICON = flagTHIcon
export const FLAG_PH_ICON = flagPHIcon
export const FLAG_ID_ICON = flagIDIcon
export const FLAG_VN_ICON_IN_RECT = flagVNIconRect
export const FLAG_TH_ICON_IN_RECT = flagTHIconRect
export const FLAG_PH_ICON_IN_RECT = flagPHIconRect
export const FLAG_ID_ICON_IN_RECT = flagIDIconRect
export const ICON_FLAG_EN = iconFlagEn
export const ICON_FLAG_ID = iconFlagId
export const ICON_FLAG_TH = iconFlagTh
export const ARROW_ICON = arrowIcon
export const ARROW_ICON_YELLOW = arrowYellowIcon
export const ICON_QUOTE_ID = iconQuoteID
export const ICON_DRIVER_PREFERENCES = iconDriverPreferences
export const ICON_FAV_DRIVER_ADDED = iconFavDriverAdded
export const ICON_DRIVER_RETRY = iconDriverRetry
export const ICON_RETRY_BOOKING_2ND_MANUAL = iconRetryBooking2ndManual
export const ICON_CANCEL_FEE = iconCancelFee
export const ICON_CEB_REQUEST_CHANGES = iconCebRequestChanges
export const ICON_CEB_RECONFIRMED_BOOKING = iconCebReconfirmedBooking
export const ICON_AVATAR_FLEET_PARTNER_ASSIGN_DRIVER = iconAvatarFleetPartnerAssignDriver
export const ICON_DRIVER_PREFERENCES_FAVORITE = iconDriverPreferencesFavorite
export const ICON_DRIVER_PREFERENCES_BANNED = iconDriverPreferencesBanned
export const ARROW_DOWN_GREEN = arrowDownGreen
export const ICON_ARROW_DOWN_DARK_GREEN = iconArrowDownDarkGreen
export const ICON_INFO_UNACTIVE = iconInfoUnActive
export const ICON_INFO_ACTIVE = iconInfoActive
export const ICON_CUSTOM_REIMBURSEMENT = iconCustomReimbursement
export const ICON_ARROW_UP = iconArrowUp
export const ICON_DRIVER_PREFERENCES_FULL = iconDriverPreferencesFull
export const ICON_NOTE_CUSTOM_PRICE = iconNoteCustomPrice
export const ICON_DRIVER_SCHEDULE = icondriverSchedule
export const ICON_SWITCH_TAB_POPUP = iconDriverPreferenceSwitchTabPopup
export const ICON_IC_ERR_CODE = iconICErrCode
export const ICON_ASSETS_DRIVER_APP = iconAssetsDriverApp
export const SCHEDULE_BOOKING_ICON_YELLOW = iconScheduleYellow
export const ICON_PERSON = iconPerson
export const ICON_PERSON_PAYMENT = iconPersonPayment

export const EXTEND_SERVICE_ICON = extendServiceIcon
export const EXTEND_MAP_ICON = extendMapIcon
export const CHANGE_TIME_TYPE_ICON = changeTimeTypeIcon
// for Devina
export const DEVINA_1_PHOTO = devina1Photo
export const DEVINA_2_PHOTO = devina2Photo
export const DEVINA_3_PHOTO = devina3Photo
export const DEVINA_4_PHOTO = devina4Photo
export const DEVINA_ICON = devinaIcon
export const RIBBON_TAIL = ribbonTail
export const ICON_WARNING_DEVINA = iconWarningDevina
export const ICON_DONE_DEVINA = iconDoneDevina
// for Multiple bookings
export const MULTIPLE_ADD_ICON = multipleAddIcon
export const MULTIPLE_SAVE_ICON = multipleSaveIcon
export const BATCH_SELECT_MULTIPLE = batchSelectMultiple
export const BATCH_SELECT_EZSHEET = batchSelectEZSheet
export const BATCH_SELECT_LOAD_DRAFT = batchSelectLoadDraft
export const BATCH_SELECT_LOAD_SAVED = batchSelectLoadSaved
export const BATCH_SELECT_START_FRESH = batchSelectStartFresh
export const CASH_BACK_PRICE_NOTE_ICON = cashBackPriceNoteIcon

// Icon for Popup
export const POPUP_ICON_SIGNATURE = popupIconSignature
export const POPUP_ICON_ATTACHED = popupIconAttached
export const POPUP_ICON_NOTES = popupIconNotes
export const POPUP_ICON_DRIVER_NOTES = popupIconDriverNotes
export const POPUP_ICON_PROOF_OF_DELIVERY = popupProofOfDelivery
export const POPUP_ICON_POD_COD = popupPodCod

export const POPUP_ICON_PRICE = popupIconPrice
export const POPUP_ICON_PRICE_CANCEL = popupIconPriceCancel
export const POPUP_ICON_ADDRESSES = popupIconAddresses
export const POPUP_ICON_ASSIGNMENT = popupIconAssignment
export const POPUP_ICON_NOTE_REQUIRE_SIGNATURES_EN = popupIconNotRequireSignaturesEN
export const POPUP_ICON_NOTE_REQUIRE_SIGNATURES_ID = popupIconNotRequireSignaturesID
export const POPUP_ICON_NOTE_REQUIRE_SIGNATURES_TH = popupIconNotRequireSignaturesTH
export const POPUP_ICON_NOTE_REQUIRE_SIGNATURES_VN = popupIconNotRequireSignaturesVN

// Icon for loading
export const LOCATING_DRIVER = locatingDriver
export const LOCATING_GIF = locatingGif
export const LOCATING_GIF_GRAY = locatingGifGray
export const LOCATING_GIF_GREEN = locatingGifGreen

// for Batch
export const INFO_ICON_EZSHEET = infoIconEZSheet
export const INFO_WHITE_ICON_EZSHEET = infoWhiteIconEZSheet
export const SETTING_ICON_EZSHEET = settingIconEZSheet
export const EXCEL_ICON_EZSHEET = excelIconEZSheet
export const EXPAND_ICON_EZSHEET = expandIconEZSheet
export const CONTACT_ICON_EZSHEET = contactIconEZSheet
export const VEHICLE_ICON_EZSHEET = vehicleIconEZSheet
export const PICKUP_ICON_EZSHEET = pickupIconEZSheet
export const MAP_ICON_EZSHEET = mapIconEZSheet
export const SEARCH_ICON_EZSHEET = searchIconMultiple
export const DUPLICATE_ICON_EZSHEET = duplicateIconEZSheet
export const DUPLICATE_SILVER_ICON_EZSHEET = duplicateSilverIconEZSheet
export const DELETE_ICON_EZSHEET = deleteIconEzsheet
export const DELETE_SILVER_ICON_EZSHEET = deleteSilverIconEzsheet
export const SAVED_ICON_EZSHEET = saveIconEzsheet
export const ICON_DISTANCE_CALCULATOR = iconDistanceCalculator
export const ADD_NEW_BOOKING = addNewBooking
export const OUTLINE_ADD_NEW_BOOKING = outlineAddNewBooking
export const UPLOAD_IMAGE = uploadImage
export const LOG_OUT_IMAGE = logOutImage
export const LOG_OUT_ICON_LOGO_PH = logOutIconLogoPH
export const LOG_OUT_ICON_LOGO = logOutIconLogo

export const PIN_MAP = [pinMap1, pinMap2, pinMap3, pinMap4, pinMap5, pinMap6, pinMap7, pinMap8, pinMap9, pinMap10]
export const INFO_BOXES = [
  infoBox1,
  infoBox2,
  infoBox3,
  infoBox4,
  infoBox5,
  infoBox6,
  infoBox7,
  infoBox8,
  infoBox9,
  infoBox10,
]
export const ANIMATE_CIRCLE = animateCircle
export const ICON_BATCH_ARRANGING = iconBatchArranging
export const ICON_BATCH_CANCELED = iconBatchCanceled
export const ICON_BATCH_COMPLETED = iconBatchCompleted
export const ICON_BATCH_COMPLETED_GREEN = iconBatchCompletedGreen
export const ICON_BATCH_COMPLETED_OUTLINE = iconBatchCompletedOutline
export const ICON_BATCH_COMPLETED_DARK = iconBatchCompletedDark
export const ICON_BATCH_COMFIRMED = iconBatchConfirmed
export const ICON_BATCH_DRAFT = iconBatchDraft
export const ICON_BATCH_INPROGRESS = iconBatchInProgress
export const ICON_BATCH_UNCOMFIRMED = iconBatchUnConfirmed
export const ICON_BATCH_NEED_CONFIRM = iconBatchNeedConfirm

// for Chat
export const QUOTE_ICON_CHAT = quoteIconChat
export const EMPTY_ICON_CHAT = emptyIconChat
export const PDF_ICON_CHAT = pdfIconChat
export const WORD_ICON_CHAT = wordIconChat
export const ASSIGN_DRIVER_ICON_CHAT = assignDriverIconChat
export const MESSAGE_DRIVER_ICON_CHAT = messageDriverIconChat
export const ICON_CHAT = iconChat

// for Long Haul
export const LONG_HAUL_GRAY_ICON = longHaulGrayIcon
export const LONG_HAUL_WHITE_ICON = longHaulWhiteIcon
export const LONG_HAUL_BLACK_ICON = longhaulBlackIcon
export const FIXED_PRICE_ICON_LONG_HAUL = fixedPriceIconLongHaul
export const FREE_INSIDE_ICON_LONG_HAUL = freeInsideIconLongHaul
export const PRICE_OUTSIDE_ICON_LONG_HAUL = priceOutsideIconLongHaul

// for new full day
export const FULL_DAY_GRAY_ICON = fullDayGrayIcon
export const FULL_DAY_DARK_GRAY_ICON = fullDayDarkGrayIcon
export const FULL_DAY_WHITE_ICON = fullDayWhiteIcon

// for completed icon
export const COMPLETED_DARK_GRAY_ICON = completedDarkGrayIcon

// for dashboad analytics
export const EXPORT_ICON = exportIconChart
export const EXPORT_EXCEL_ICON = exportExcelIconChart
export const EXPORT_XLS_ICON = exportXLSIcon
export const EXPORT_DOWNLOAD_FAIL = exportDownloadFailIcon
export const EXPORT_PDF_ICON = exportPDFIconChart
export const DOWNLOAD_PDF_ICON = downloadPDFIconChart
export const AVG_CHART_ICON = avgIconChart
export const LOADING_CHART_ICON = loadingIconChart
export const NO_DATA_CHART_ICON = noDataIconChart
export const ANALYTICS_REPORT_ICON = analyticsReportIconChart
export const DROPDOWN_ICON = iconDropdown

// for Round Trip Discount
export const ROUND_TRIP_DISCOUNT_PIN_NONE_ICON = roundTripDiscountPinNoneIcon
export const ROUND_TRIP_DISCOUNT_PIN_ICON = {
  en: pinRoundTripIcon,
  id: pinRoundTripIconID,
  th: pinRoundTripIconTH,
}

// for Export Booking
export const FILTER_EXPORT_ICON = filterExportIcon
// for full day megazone
export const MEGAZONE_NOTICE_ICON = megazoneNoticeIcon
export const CLOSE_MEGAZONE_NOTICE_ICON = closeNoticeMegazoneIcon

// for locating driver default image
export const LOCATING_DRIVER_DEFAULT_IMAGE = locatingDriverDefaultImage
// for Reassign batch booking
export const REASSIGN_ICON = reassignIcon

// Preference Drivers
export const ICON_CAR_GRAY = iconCarGray
export const NO_DRIVER_FOUND = noDriverFound
export const FAVORITE_ICON = favoriteIcon
export const UN_FAVORITE_ICON = unFavoriteIcon
export const BANNED_ICON = bannedIcon
export const UN_BANNED_ICON = unbannedIcon
export const ICON_EDIT_LOCATIONS = iconEditLocations
export const FAVORITE_GRAY_ICON = favoriteGrayIcon

// for My Location
export const LOCATION_ICON = locationIcon
export const LOCATION_NAME_ICON = locationNameIcon
export const LOCATION_ADDRESS_ICON = locationAddressIcon
export const LOCATION_NUMBER_ICON = locationNumberIcon
export const LOCATION_TITLE_ICON = locationTitleIcon
export const LOCATION_EMAIL_ICON = locationEmailIcon
export const LOCATION_COMPANY_ICON = locationCompanyIcon
export const TRASH_ICON = trashIcon
export const ADDRESS_DETAIL_ICON = addressDetailIcon

export const CALENDAR_ICON = calendarIcon
export const QUICK_CHOICE_ICON = quickChoiceIcon
export const BP_ACCOUNT = bpAccount
export const SWITCH_ACCOUNT = switchAccount
export const ARROW_RIGHT_GREEN = arrowRightGreen
export const ARROW_BACK_WHITE = arrowBackWhite
export const HAMBUGER_COMMON_ICON = hambugerCommonIcon
export const CLEAR_COMMON_ICON = clearCommonIcon
export const LOCATION_COMMON_ICON = locationCommonIcon
export const REMOVE_COMMON_ICON = removeCommonIcon
export const SAVE_COMMON_ICON = saveCommonIcon
export const GPS_COMMON_ICON = gpsCommonIcon
export const PATH_COMMON_ICON = pathCommonIcon
export const MOVE_DRAG_ICON = moveDragIcon

export const DISTANCE_CALCULATOR = distanceCalculator
export const ICON_CHECKED_DEFAULT = iconCheckeDefault

export const DELETE_ICON = deleteIconConfirm

// Shopping
export const COPY_SHOPPING = copyShopping
export const WALLET_SHOPPING = walletShopping
export const BLOCK_BOOKING_SHOPPING = blockBookingShopping
export const CART_SHOPPING = cartShopping
export const TRASH_ICON_SHOPPING = trashIconShopping
export const TRASH_ICON_WHITE_SHOPPING = trashIconWhiteShopping
export const CHECK_ICON_SHOPPING = checkIconShopping
export const CHECK_GRAY_ICON_SHOPPING = checkGrayIconShopping
export const TRIANGLE_ICON_SHOPPING = triangleIconShopping
export const ITEM_BREAKDOWN_ICON_SHOPPING = itemBreakdownIconShopping

// CPOD
export const EMAIL_EXPRESS = emailExpress
export const OPTIONAL_NOTE = optionalNote

// NUMBER DRIVER
export const NUMBER_DRIVER_LEFT = numberDriverLeft
export const NUMBER_DRIVER_RIGHT = numberDriverRight
export const VEHICLE_ICON = vehicleIcon

// DYNAMIC SETTING BUFFER TIME
export const ICON_TIMETYPE_FULLDAY = iconTimetypeFullday
export const ICON_TIMETYPE_QUICK = iconTimetypeQuick
export const ICON_TIMETYPE_SCHEDULE = iconTimetypeSchedule
export const ICON_TIMETYPE_LONGHAUL = iconTimetypeLonghaul

// LTL ICON
export const ICON_LTL_POPUP_LOGO = iconMapLTlPopup
export const ICON_LTL_SCHEDULE_LOGO = iconScheduleLTL

// default avatar
export const DRIVER_DEFAULT_AVATAR = driverDefaultAvatar

export const NO_FAVORITE_DRIVERS = noFavoriteDrivers
export const QUESTION_ICON = questionIcon
export const QUESTION_ICON_GRAY = questionIconGray
export const QUESTION_ICON_GREEN = questionIconGreen
export const NOUN_USER_TAG_ICON = nounUserTagIcon
export const GREEN_NOUN_USER_TAG_ICON = greenNounUserTagIcon
export const WHITE_NOUN_USER_TAG_ICON = whiteNounUserTagIcon
export const SEARCH_ICON = searchIcon

export const SMART_PLANNER_SELECT = smartPlannerSelect
export const EZ_SHEET_UPLOAD = ezSheetUpload
export const SCHEDULE_GREY = scheduleGrey
export const BUS_GRAY = busGray

export const BOOKING_OPTIONS = bookingOptions
export const UP_DOWN_ICON = upAndDownIcon

export const RE_ORDER_ICON = Reorder
export const INFO_GREEN_ICON = infoGreen
export const RE_ORDER_GREEN = ReorderGreen

export const ACCOUNT_ICON = account
export const SCHEDULE_CLOCK = scheduleClock

export const WALLET_ICON = walletIcon
export const WALLET_GRAY = walletGraytIcon
export const LUCKY_STAR = startIcon
export const BREAK_FILE = breakFile
export const IMAGE_PLACE_HOLDER = imagePlaceHolder
export const MAP_GREEN = mapGreen
export const MAP_GRAY = mapGray
export const UNDO_ICON = undoIcon
export const UNDO_RED_ICON = undoRedIcon
export const UNDO_BLACK_ICON = undoBlackIcon
export const LIGHT_PUB = lightPub
export const JOB_NUMBER_ICON = jobNumberIcon

export const COMPUTER_BATCH_ICON = computerBatchIcon
export const EXCEL_BATCH_ICON = excelBatchIcon
export const MAP_ICON_LOAD_PLAN = mapIconLoadPlan
export const TMS_ICON = tmsIcon
export const OPEN_TMS_ICON = opentmsIcon
export const INVALID_ACCOUNT = invalidAccount
export const ACCOUNT_CHECK = accountCheck
export const CLOSE_ICON = closeIcon

export const BACKGROUND_SELECT_AREA = backgroundImage
export const NO_LOCATION = noLocation
export const SWITCH_ICON_GRAY = switchRoleIcon
export const SWITCH_ICON_COLOR = switchRoleIconColor
export const BAN_ICON_GRAY = banIcon
export const BAN_ICON_COLOR = banIconColor
export const DELETE_ICON_GRAY = deleteEmployeeIcon
export const DELETE_ICON_COLOR = deleteEmployeeIconColor
export const ARROW_UP_RIGHT = arrowUpRight

// New Tracking Booking
export const ICON_LOGO_WHITE = whiteLogo
export const V2_ICON_WHITE_TRANSPORTIFY = whiteLogoTransportify
export const ICON_COPE_GREEN = greenCopy
export const ICON_SHUTTLE_STOCK = shutterStock
export const ICON_PLAY_STORE_ANDROID = playStoreAndroid
export const ICON_PLAY_STORE_IOS = playStoreIOS
export const ICON_BOOKED = booked
export const ICON_DISPATCH = dispatch
export const ICON_PICKUP = pickup
export const ICON_DELIVERY = delivery
export const ICON_BOOKED_ON_GOING = bookedOnGoing
export const ICON_DISPATCH_ON_GOING = dispatchOnGoing
export const ICON_PICKUP_ON_GOING = pickupOnGoing
export const ICON_DELIVERY_ON_GOING = deliveryOnGoing
export const ICON_BOOKED_COMPLETED = bookedCompleted
export const ICON_DISPATCH_COMPLETED = dispatchCompleted
export const ICON_PICKUP_COMPLETED = pickupCompleted
export const ICON_DELIVERY_COMPLETED = deliveryCompleted
export const ICON_DELIVERY_BOOK_COMPLETED = deliveryBookingCompleted
export const ICON_DELIVERY_BOOK_CANCELED = deliveryBookingCanceled
export const ICON_PROGRESS_CHECK = check
export const INFO_WITH_BORDER = infoWithBorder
export const BG_BITMAP = bitmap
export const BG_BITMAP_WITHOUT_RADIAN = bitmapWithoutRadian
export const INVALID_LINK = invalidLink
export const ARROW_LEFT_WHITE = arrowLeftWhite
export const PAID_PAYMENT_ICON = paidPaymentIcon
export const FTL_FRONT_PAGE = ftlFrontPage
export const PTL_FRONT_PAGE = ptlFrontPage
export const LCL_FRONT_PAGE = lclFrontPage
export const MORE_FRONT_PAGE_SERVICE = moreFrontPageService
export const MORE_FRONT_PAGE_SERVICE_ID = moreFrontPageServiceId
export const MORE_FRONT_PAGE_CONTAINER = moreFrontPageContainer
export const NEW_AD_PANEL = newAdPanel
export const MORE_FRONT_PAGE_SAVER = saverLaunchAdPanel
export const NO_SIGN_IN = noSignIn
export const LIVE_CHAT = liveChat
export const FINAL_LEO_GRAPHIC = finalLeoGraphic
export const SUMATRA = sumatra
export const BACK_TO_TOP_ICON = backToTopIcon
export const LCL_BOOKING_ICON = lclBookingIcon
export const LCL_CAR_ICON = lclCarIcon
export const LCL_SHIP_ICON = lclShipIcon
export const LCL_CALENDAR_ICON = lclCalendarIcon
export const LCL_TIME_ICON = lclTimeIcon

// TOPUP
export const TOPUP_FAIL = topUpFail
export const TOPUP_CHECK = topUpCheck
export const COPY = copy

// Share social network
export const IMAGE_SHARING_TRANSPORTIFY = imageSharing_transportify
export const IMAGE_SHARING_DELIVEREE = imageSharing_deliveree

// Saver
export const SAVER_BLOCK_INFO_ICON = saverBlockInfoIcon
export const CONTACT_CS = contactCS

export const NEW_PIN_TO = newPinTo
export const NEW_PIN_FROM = newPinFrom
export const NEW_PIN_RED = newPinRed

export const PIN_FROM_DRAP_DROP = pinFromDrapDrop
export const PIN_FROM_DRAP_DROP_EN = pinFromDrapDropEn
export const PIN_FROM_DRAP_DROP_ID = pinFromDrapDropId
export const PIN_FROM_DRAP_DROP_TH = pinFromDrapDropTh

export const PIN_TO_DRAP_DROP = pinToDrapDrop
export const PIN_TO_DRAP_DROP_EN = pinToDrapDropEn
export const PIN_TO_DRAP_DROP_ID = pinToDrapDropId
export const PIN_TO_DRAP_DROP_TH = pinToDrapDropTh

export const SHOW_MORE_LOCATION = showMoreLocation

// NEW DETAILS BOOKING
export const CASH_BACK_STAR = cashBackStar
export const WARNING_YELLOW = warningYellow
export const CARET_DOWN = caretDown
export const CARET_DOWN_WHITE = caretDownWhite